<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <router-view></router-view>
  </div>
</template>

<script>
export default {
    data(){
      return{
        
      }
    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue